export default "__VITE_ASSET__b0895f7d__"